// Popping a map out into its own real browser window is just a second load of the same
// /game/:gameId route in a new window — cookies (and therefore auth) are shared automatically
// since it's same-origin, and each window gets its own independent Zustand store + websocket
// connection with zero extra plumbing. `?popout=1&scene=<id>` tells GameRoomPage to strip the
// chrome (chat/sheet/voice dock, bottom nav, dashboard/raid nav) and jump straight to that scene.
const COUNT_KEY = "cta_popout_open_count";
const MAX_POPOUTS = 50;

export function openMapPopout(gameId, sceneId) {
  const current = parseInt(localStorage.getItem(COUNT_KEY) || "0", 10);
  if (current >= MAX_POPOUTS) return false;
  localStorage.setItem(COUNT_KEY, String(current + 1));
  const params = new URLSearchParams({ popout: "1" });
  if (sceneId) params.set("scene", sceneId);
  const name = `cta-popout-${gameId}-${sceneId || "current"}-${Date.now()}`;
  window.open(`/game/${gameId}?${params.toString()}`, name, "width=1440,height=960,resizable=yes,scrollbars=yes");
  return true;
}

export function releasePopoutSlot() {
  const current = parseInt(localStorage.getItem(COUNT_KEY) || "0", 10);
  localStorage.setItem(COUNT_KEY, String(Math.max(0, current - 1)));
}

// Story/Lore Books open the exact same way — a real second window onto a dedicated
// full-page route, same-origin so the GM's auth cookie just works with zero extra plumbing.
export function openBookPopout(gameId, bookType) {
  const name = `cta-book-${gameId}-${bookType}`;
  window.open(`/game/${gameId}/book/${bookType}`, name, "width=1280,height=900,resizable=yes,scrollbars=yes");
}

// Game Show Scoreboard — same real-second-window trick, so the host (or anyone watching) can
// drag it to a second monitor and it just keeps live-updating over its own websocket connection.
export function openScoreboardPopout(showId) {
  const name = `cta-scoreboard-${showId}`;
  window.open(`/gameshow/${showId}/scoreboard`, name, "width=520,height=760,resizable=yes,scrollbars=yes");
}
